import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from '@COMPONENTS/HEADERS/Header';
import MainHeader from '@COMPONENTS/HEADERS/MainHeader';
import AdminSubheader from '@COMPONENTS/HEADERS/AdminSubheader';

function BasicAdminLayout() {
    return (
        <>
            <Header>
                <MainHeader />
                <AdminSubheader />
            </Header>

            <main>
                <Outlet />
            </main>
        </>
    );
}

export default BasicAdminLayout;
